import { render, staticRenderFns } from "./Superusers.vue?vue&type=template&id=e8c1614a&"
import script from "./Superusers.vue?vue&type=script&lang=js&"
export * from "./Superusers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports